<div class="driver-details-tooltip">
  <div class="tooltip-head py-spacing-xs px-spacing-md form-label-bg">
    <div class="flex justify-content-between gap-spacing-2xl align-items-center">
      <div class="flex align-items-center gap-spacing-xs">
        <span class="label-medium-medium text-inverse-color">{{ driver()?.fullName }}</span>
        <span class="label-medium-regular form-border-default-color">{{ driver()?.plateNumber }} - {{ driver()?.vehicleType }}</span>
      </div>
      <i id="closeBtn"
         (click)="closed.emit()" (keydown.enter)="closed.emit()"
         class="background-surface-base-alpha-10-bg size-icon-md capitalize cursor-pointer text-inverse-color border-round-xs p-spacing-3xs icon-x"></i>
    </div>
    <span class="label-medium-regular form-border-default-color inline-block mt-spacing-2xs">{{ driver()?.partnerId }}</span>
  </div>

  <div class="tooltip-body background-fill-tertiary-bg px-spacing-md py-spacing-xs">
    <div class="item flex justify-content-between align-items-center gap-spacing-md">
      <span class="label-medium-regular form-border-default-color">Driver Provider</span>
      <span class="label-medium-medium text-inverse-color">{{ driver()?.organization }}</span>
    </div>
    <div class="item flex justify-content-between align-items-center gap-spacing-md">
      <span class="label-medium-regular form-border-default-color">Mobile Number</span>
      <span class="label-medium-medium text-inverse-color">{{ driver()?.mobileNumber }}</span>
    </div>
    <div class="item flex justify-content-between align-items-center gap-spacing-md">
      <span class="label-medium-regular form-border-default-color">Address</span>
      <span class="label-medium-medium text-inverse-color">{{ driver()?.address }}</span>
    </div>
    <div class="item flex justify-content-between align-items-center gap-spacing-md">
      <span class="label-medium-regular form-border-default-color"># of Assignments</span>
      <span class="label-medium-medium text-inverse-color">{{ driver()?.assignmentCount }}</span>
    </div>
    <div class="item mb-0 pb-0 border-bottom-none flex justify-content-between align-items-center gap-spacing-md">
      <span class="label-medium-regular form-border-default-color"># of Sub-Assignments</span>
      <span class="label-medium-medium text-inverse-color">{{ driver()?.subassignmentCount }}</span>
    </div>

    <div class="my-spacing-md flex flex-column gap-spacing-2xs px-spacing-md py-spacing-2xs border-round-sm background-fill-primary-bg">
      <div class="flex align-items-center gap-spacing-xs">
        <i class="icon-info-solid text-inverse-color size-icon-md"></i>
        <span class="label-medium-regular text-inverse-color">
          {{ driver()?.bestMatch == 100 ? "This driver matches this route" : "This driver missing this route:" }}
        </span>
      </div>

      @for (reason of driver()?.moreInfo?.reasons; track $index) {
      <span class="label-medium-regular text-inverse-color pl-spacing-3xl">- {{ reason.details }}</span>
      }
    </div>

    <div class="grid">
      <div class="col-6">
        <button (click)="hide.emit(driver()!)"
                id="hideBtn"
                class="w-full p-button p-button-md p-button-secondary">
          Hide From Search
        </button>
      </div>
      <div class="col-6">
        <button (click)="assign.emit(driver()!)"
                [disabled]="driver()?.bestMatch! <= 50"
                id="assignBtn"
                class="w-full p-button p-button-md p-button-primary">
          Assign
        </button>
      </div>
    </div>
  </div>
</div>
